"use client";
import { useState, useMemo } from "react";
import { usePathname } from "next/navigation";
import Navbar from "@/components/Navbar/Navbar";
import SidebarRight from "@/components/Navbar/SidebarRight";

export default function NavbarShell({ patternStrings }) {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  // RegExp erst hier erzeugen (nur 1×, dank useMemo)
  const patterns = useMemo(
    () => ({
      withDark: patternStrings.withDark.map((s) => new RegExp(s, "i")),
      nonSticky: patternStrings.nonSticky.map((s) => new RegExp(s, "i")),
      rerouteLanding: patternStrings.rerouteLanding, // bleibt Array<string>
    }),
    [patternStrings]
  );

  const isNavbarDark = patterns.withDark.some((rx) => rx.test(pathname));
  const isNavbarSticky = !patterns.nonSticky.some((rx) => rx.test(pathname));
  const isRerouting = patterns.rerouteLanding.includes(pathname);

  return (
    <>
      <SidebarRight isSidebarOpen={isOpen} setIsSidebarOpen={setIsOpen} />
      <div className={isOpen ? "overlay active" : "overlay"} />
      <Navbar
        isNavbarDark={isNavbarDark}
        isNavbarSticky={isNavbarSticky}
        isReroutingToLanding={isRerouting}
        setIsSidebarOpen={setIsOpen}
      />
    </>
  );
}
